import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from '@mui/material';
import React from 'react';

const SchedulerDetailsTable = (props) => {
  return (
    <div>
      <TableContainer
        component={Paper}
        sx={{
          marginTop: '1rem',
          boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)',
          borderRadius: '8px',
          overflow: 'hidden',
        }}
      >
        <Table>
          <TableHead>
            <TableRow>
              <TableCell
                align='center'
                sx={{
                  backgroundColor: '#939193',
                  color: '#fff',
                  fontWeight: 'bold',
                  fontSize: '1rem',
                  textTransform: 'uppercase',
                }}
              >
                Scheduler Name
              </TableCell>
              <TableCell
                align='center'
                sx={{
                  backgroundColor: '#939193',
                  color: '#fff',
                  fontWeight: 'bold',
                  fontSize: '1rem',
                  textTransform: 'uppercase',
                }}
              >
                Scheduler Details
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {props.addedtempSchedulers?.map((scheduler, i) => {
              return (
                <TableRow
                  key={i}
                  sx={{
                    '&:nth-of-type(odd)': { backgroundColor: '#f9f9f9' },
                    '&:nth-of-type(even)': { backgroundColor: '#f1f1f1' },
                  }}
                >
                  <TableCell
                    align='center'
                    sx={{
                      fontWeight: '500',
                      fontSize: '0.9rem',
                      padding: '1rem',
                    }}
                  >
                    {scheduler.scheduleName}
                  </TableCell>
                  <TableCell>
                    <Table>
                      <TableHead>
                        <TableRow>
                          <TableCell
                            align='center'
                            sx={{
                              backgroundColor: '#939193',
                              color: '#fff',
                              fontWeight: 'bold',
                              fontSize: '0.9rem',
                            }}
                          >
                            Date / Day
                          </TableCell>
                          <TableCell
                            align='center'
                            sx={{
                              backgroundColor: '#939193',
                              color: '#fff',
                              fontWeight: 'bold',
                              fontSize: '0.9rem',
                            }}
                          >
                            Time
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {scheduler.scheduleDateTimes?.map((dateData, k) => {
                          return (
                            <TableRow
                              key={k}
                              sx={{
                                '&:nth-of-type(odd)': {
                                  backgroundColor: '#fefefe',
                                },
                                '&:nth-of-type(even)': {
                                  backgroundColor: '#fafafa',
                                },
                              }}
                            >
                              <TableCell align='center'>
                                {dateData.isDays ? (
                                  <>
                                    {dateData.scheduleDays.map(
                                      (scheduleday, k) => {
                                        return (
                                          <div
                                            className={`d-flex `}
                                            style={{
                                              gap: '10px',
                                              justifyContent: 'center',
                                            }}
                                          >
                                            <button
                                              className={` circleBtn ${
                                                scheduleday.isSaturday
                                                  ? 'colorSelected '
                                                  : 'colorNotSelected'
                                              } `}
                                            >
                                              S
                                            </button>
                                            <button
                                              className={` circleBtn ${
                                                scheduleday.isMonday
                                                  ? 'colorSelected '
                                                  : 'colorNotSelected'
                                              } `}
                                            >
                                              M
                                            </button>
                                            <button
                                              className={` circleBtn ${
                                                scheduleday.isTuesday
                                                  ? 'colorSelected '
                                                  : 'colorNotSelected'
                                              } `}
                                            >
                                              T
                                            </button>
                                            <button
                                              className={` circleBtn ${
                                                scheduleday.isWednesday
                                                  ? 'colorSelected '
                                                  : 'colorNotSelected'
                                              } `}
                                            >
                                              W
                                            </button>
                                            <button
                                              className={` circleBtn ${
                                                scheduleday.isThursday
                                                  ? 'colorSelected '
                                                  : 'colorNotSelected'
                                              } `}
                                            >
                                              T
                                            </button>
                                            <button
                                              className={` circleBtn ${
                                                scheduleday.isFriday
                                                  ? 'colorSelected '
                                                  : 'colorNotSelected'
                                              } `}
                                            >
                                              F
                                            </button>
                                            <button
                                              className={` circleBtn ${
                                                scheduleday.isSunday
                                                  ? 'colorSelected '
                                                  : 'colorNotSelected'
                                              } `}
                                            >
                                              S
                                            </button>
                                          </div>
                                        );
                                      }
                                    )}
                                  </>
                                ) : (
                                  <>
                                    {new Date(
                                      dateData.fromDate
                                    ).toLocaleDateString('en-GB', {
                                      day: '2-digit',
                                      month: 'short',
                                      year: 'numeric',
                                    })}{' '}
                                    -{' '}
                                    {new Date(
                                      dateData.toDate
                                    ).toLocaleDateString('en-GB', {
                                      day: '2-digit',
                                      month: 'short',
                                      year: 'numeric',
                                    })}
                                  </>
                                )}
                              </TableCell>
                              <TableCell align='center'>
                                {dateData.isAllDay ? (
                                  <>All Day</>
                                ) : (
                                  <>
                                    {new Date(
                                      '1970-01-01T' + dateData.fromTime
                                    ).toLocaleTimeString('en-US', {
                                      hour: '2-digit',
                                      minute: '2-digit',
                                      hour12: true,
                                    })}{' '}
                                    -{' '}
                                    {new Date(
                                      '1970-01-01T' + dateData.toTime
                                    ).toLocaleTimeString('en-US', {
                                      hour: '2-digit',
                                      minute: '2-digit',
                                      hour12: true,
                                    })}
                                  </>
                                )}
                              </TableCell>
                            </TableRow>
                          );
                        })}
                      </TableBody>
                    </Table>
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
};

export default SchedulerDetailsTable;
